const i = "ids-loading--error-v5150", d = {
  "fade-in": "ids-loading--fade-in-v5150",
  "fade-in--active": "ids-loading--fade-in--active-v5150",
  "slide-in": "ids-loading--slide-in-v5150",
  "slide-in--active": "ids-loading--slide-in--active-v5150",
  "fade-next": "ids-loading--fade-next-v5150",
  "fade-next-width": "ids-loading--fade-next-width-v5150",
  "slide-next": "ids-loading--slide-next-v5150",
  error: i
};
export {
  d as l
};
